'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { MarkdownPreview } from '../../../../markdown-preview';
import { JSONRenderer } from '../../ToolCallsRenderers/renderers/JSONRenderer';
import { MarkdownRenderer } from '../../ToolCallsRenderers/renderers/MarkdownRenderer';
import { PlainTextRenderer } from '../../ToolCallsRenderers/renderers/PlainTextRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderJsonResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  return <JSONRenderer data={content} maxHeight={maxHeight} />;
};

export const renderMarkdownResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  return <MarkdownRenderer content={String(content)} maxHeight={maxHeight} />;
};

export const renderThinkingStyleMarkdownResult = (
  ctx: OutputRenderContext,
): ReactNode => {
  const { content, maxHeight } = ctx;

  return (
    <Box
      width="100%"
      maxHeight={maxHeight}
      overflow={maxHeight ? 'auto' : undefined}
      color="fg.muted"
      fontSize="xs"
    >
      <MarkdownPreview source={String(content)} fontSize={12} compact />
    </Box>
  );
};

export const renderPlainTextResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;

  return <PlainTextRenderer content={String(content)} maxHeight={maxHeight} />;
};

export const renderCodeResult = ({
  language,
}: {
  language: string;
}): ((ctx: OutputRenderContext) => ReactNode) => {
  return (ctx: OutputRenderContext): ReactNode => {
    const { content, maxHeight } = ctx;

    return (
      <MarkdownRenderer
        content={`\`\`\`${language}\n${String(content)}\n\`\`\``}
        maxHeight={maxHeight}
      />
    );
  };
};
